import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

function Index({ children, ...props })
{
    return (
        <Helmet {...props}>
            {children}
        </Helmet>
    );
}

Index.propTypes = {
  children: PropTypes.node.isRequired
}

export default Index;
